module.exports = __webpack_public_path__ + "static/us-fa563627097b131b0da1075bbd4a9cba.svg";